import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {RouteReuseStrategy} from '@angular/router';

import {IonicModule, IonicRouteStrategy} from '@ionic/angular';
import {SplashScreen} from '@ionic-native/splash-screen/ngx';
import {StatusBar} from '@ionic-native/status-bar/ngx';
import {IonicStorageModule} from '@ionic/storage';
import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {ServiceWorkerModule} from '@angular/service-worker';
import {RequestInterceptor} from './ngage-apps/lots/request.interceptor';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import { AuthGuard } from './ngage-apps/lots/MU_pages/toyota-pages/guard/auth-guard.service';

@NgModule({
    declarations: [AppComponent],
    entryComponents: [],
    imports: [
        BrowserModule,
        HttpClientModule,
        IonicModule.forRoot(),
        IonicStorageModule.forRoot(),
        AppRoutingModule
    ],
    providers: [
        StatusBar,
        SplashScreen,
        AuthGuard,
        {provide: RouteReuseStrategy, useClass: IonicRouteStrategy},
        {
            provide: HTTP_INTERCEPTORS,
            useClass: RequestInterceptor,
            multi: true,
        },
        {provide: LocationStrategy, useClass: HashLocationStrategy},

    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}








